import React from 'react';
import styled from 'react-emotion';
import { HitBox, hitBox } from './utils/HitBox';
//import FrenzyColors from './FrenzyStyles';


/** Player is (when scaled 1x):
 * 
 * bbbbbbb
 * b     b
 * b     b
 * b  c  b
 * b     b
 * b     b
 * bbbbbbb
 * 
 * Overall it's 7px square
 * The 1px square centre has 2px of "radius" and a 1px border.
 */

/** Player is (when scaled 2x):
 * 
 * bbbbbbbbbbbbbb
 * bbbbbbbbbbbbbb
 * bb          bb    
 * bb          bb
 * bb          bb
 * bb          bb
 * bb    cc    bb
 * bb    cc    bb
 * bb          bb
 * bb          bb
 * bb          bb
 * bb          bb
 * bbbbbbbbbbbbbb
 * bbbbbbbbbbbbbb
 * 
 * Overall it's 14px square
 * The 2px square centre has 4px of "radius" and a 2px border.
 */

 type PlayerBoxProps = {
	 scale: number;
	 moveable: boolean;
	 dying?: boolean;
 }

const SCALE_FACTOR = 7;
const HALF_WIDTH = 3;
const PlayerBox = styled('div')<PlayerBoxProps>`
	display: inline-block;
	box-sizing: border-box;
	border: ${props => `${props.scale}px solid ${props.dying ? '#000' : '#fff'}`};
	padding: 0;
	width: ${props => `${(props.scale * SCALE_FACTOR)}px`};
	height: ${props => `${(props.scale * SCALE_FACTOR)}px`};
	margin: 0;
	position: ${props => props.moveable ? 'absolute' : 'relative'};
`;

type Props = {
	x?: number;
	y?: number;
	scale?: number;
	testID?: string;
	moveable?: boolean;
	dying?: boolean;
}

class Player extends React.PureComponent<Props> {
	render() {

	const { x = 0, y = 0, scale = 1, testID = "player", dying,  moveable = true} = this.props;
	const halfWidth = scale * HALF_WIDTH;
	return (
		<PlayerBox 
			data-testid={testID}
			moveable={moveable} 
			scale={scale}
			style={{ left: `${x - halfWidth}px`, top: `${y - halfWidth}px`}}
			dying={dying}
		>
			<div style={{ width: `${scale}px`, height: `${scale}px`, color: "#fff" }} >
			
			</div>
		</PlayerBox>
		);
	}
}

export function getPlayerHitBox(x: number, y: number): HitBox {
	return hitBox(x, y, HALF_WIDTH);
}

export default Player;
